import { useEffect, useRef } from 'react'

import { HttpMethod } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import { traceHelpCenter } from '@/Shared/infrastructure/endpoints'

declare global {
  interface Window {
    Genesys?: GenesysAPI
    _genesysJs?: string
  }
}

type GenesysAPI = {
  (command: 'subscribe', event: string, callback: () => void): void
  (
    command: 'command',
    event: string,
    options?: Record<string, unknown>,
    onSuccess?: (...args: unknown[]) => void,
    onError?: (err: { code: string }) => void,
  ): void
}

const GENESYS_SCRIPT_ID = 'genesys-bootstrap-script'

const loadGenesysScript = (): void => {
  if (document.getElementById(GENESYS_SCRIPT_ID)) return
  ;(function (g: any, e: any, n: any, es: any, ys: any) {
    g['_genesysJs'] = e
    g[e] =
      g[e] ||
      function () {
        ;(g[e].q = g[e].q || []).push(arguments)
      }
    g[e].t = new Date().getTime()
    g[e].c = es
    ys = document.createElement('script')
    ys.id = GENESYS_SCRIPT_ID
    ys.async = true
    ys.src = n
    ys.charset = 'utf-8'
    document.head.appendChild(ys)
  })(
    window,
    'Genesys',
    import.meta.env.VITE_GENESYS_SCRIPT_URL,
    {
      environment: import.meta.env.VITE_GENESYS_ENVIRONMENT,
      deploymentId: import.meta.env.VITE_GENESYS_DEPLOYMENT_ID,
    },
    null,
  )
}

const fetchTrace = (): void => {
  const trace = axiosFetch(traceHelpCenter, HttpMethod.POST, undefined)
}

export const GenesysCoBrowsing = (): JSX.Element | null => {
  useEffect(() => {
    loadGenesysScript()

    window.Genesys?.('subscribe', 'Messenger.ready', () => {
      window.Genesys?.('command', 'Messenger.open')
    })

    fetchTrace()
  }, [])

  return null
}
